import { z } from 'zod'
import { CONSENT_VERSIONS, PAPER_COPY_NOTE_MAX } from '../constants/envelope.js'
import { fieldValueDtoSchema } from '../dto/envelope.dto.js'
import { uuidSchema } from '../validators/params.js'

export const acceptConsentInputSchema = z
  .object({
    version: z.enum(CONSENT_VERSIONS),
  })
  .strict()

export type AcceptConsentInput = z.infer<typeof acceptConsentInputSchema>

const signingFields = z
  .array(
    z
      .object({
        id: uuidSchema,
        value: fieldValueDtoSchema,
      })
      .strict(),
  )
  .max(200)

export const completeSigningInputSchema = z
  .object({
    fields: signingFields,
  })
  .strict()

export type CompleteSigningInput = z.infer<typeof completeSigningInputSchema>

/**
 * A signer's draft so far, and the draft revision it was based on. A save from
 * an older revision is refused (`409 signing.draft_conflict`), so a second tab
 * can't overwrite a newer draft. A page from before revisions sends none and
 * isn't checked.
 */
export const saveSigningDraftInputSchema = z
  .object({
    fields: signingFields,
    revision: z.number().int().nonnegative().optional(),
  })
  .strict()

export type SaveSigningDraftInput = z.infer<typeof saveSigningDraftInputSchema>

export const declineSigningInputSchema = z
  .object({
    reason: z.string().trim().min(1).max(2000),
  })
  .strict()

export type DeclineSigningInput = z.infer<typeof declineSigningInputSchema>

/** A signer asking the organization for a paper copy, optionally saying where to send it. */
export const requestPaperCopyInputSchema = z
  .object({
    note: z.string().trim().max(PAPER_COPY_NOTE_MAX).optional(),
  })
  .strict()

export type RequestPaperCopyInput = z.infer<typeof requestPaperCopyInputSchema>
